"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldType = void 0;
const fieldTypes = {
    string: {
        dataToValue: (data) => (data ? data : ""),
        valueToData: (value) => (value ? value : null),
    },
    number: {
        dataToValue: (data) => (data != null ? "" + data : ""),
        valueToData: (value) => (value ? +value : null),
    },
    boolean: {
        dataToValue: (data) => (data != null ? "" + data : ""),
        valueToData: (value) => (value ? "true" == value : null),
    },
    stringList: {
        dataToValue: (data) => (data != null ? data.join(",") : ""),
        valueToData: (value) => (value ? value.split(",") : null),
    },
    numberList: {
        dataToValue: (data) => (data != null ? data.join(",") : ""),
        valueToData: (value) => (value ? value.split(",").map((s) => +s) : null),
    },
};
/** Return FieldType from its name */
function getFieldType(typeName) {
    const type = fieldTypes[typeName];
    if (!type) {
        throw new Error(`Unsupported field type ${typeName} for field ${name}`);
    }
    return type;
}
exports.getFieldType = getFieldType;
